export default __webpack_public_path__ + "static/media/learose2-480w.c2ac2de0.png";